import { GameManager } from "../GameManager";
import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { AudioManager } from "../AudioManager";

export class PreloadScene extends Phaser.Scene {

    public static currentInstance: PreloadScene;

    private progressBar: Phaser.GameObjects.Graphics;

    constructor() {

        super("PreloadScene");
    }

    public preload(): void {

        this.composeScene();

        this.loadAssets();

        // HACK PARA QUE SE VEA BIEN EN EL IPHONE 5 
        if (window.innerWidth === 568) {
            document.getElementById("content").style.height =  "226px";
            GameVars.scaleX = (GameConstants.GAME_WIDTH / GameConstants.GAME_HEIGHT) / (window.innerWidth / window.innerHeight);
        }
    }

    public create(): void {

        PreloadScene.currentInstance = this;

        GameManager.setCurrentScene(this);

        this.loadHowl();
    }
    
    private composeScene(): void {

        this.add.text(10, 10, "ABCDEFG", {fontFamily: "BladiTwo4F", fontSize: "20px", color: "#FFFFFF", align: "center"});
    
        this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "background");
       
        const loadingText = this.add.text(10, GameConstants.GAME_HEIGHT - 55, GameVars.languages[GameVars.gameData.language]["LOADING"], {fontFamily: "BladiTwo4F", fontSize: "36px", color: "#FFFFFF", align: "center"});
        loadingText.scaleX = GameVars.scaleX;
       
        this.progressBar = this.add.graphics();
    }

    private loadAssets(): void {

        this.load.atlas("texture_atlas_1", "assets/texture_atlas_1.png", "assets/texture_atlas_1.json");
        this.load.atlas("texture_atlas_2", "assets/texture_atlas_2.png", "assets/texture_atlas_2.json");
        this.load.atlas("texture_atlas_3", "assets/texture_atlas_3.png", "assets/texture_atlas_3.json");
        this.load.atlas("texture_atlas_4", "assets/texture_atlas_4.png", "assets/texture_atlas_4.json");

        this.load.atlas("texture_atlas_5_en", "assets/texture_atlas_5_en.png", "assets/texture_atlas_5_en.json");
        this.load.atlas("texture_atlas_5_es", "assets/texture_atlas_5_es.png", "assets/texture_atlas_5_es.json");
        this.load.atlas("texture_atlas_5_de", "assets/texture_atlas_5_de.png", "assets/texture_atlas_5_de.json");
        this.load.atlas("texture_atlas_5_br", "assets/texture_atlas_5_br.png", "assets/texture_atlas_5_br.json");
        this.load.atlas("texture_atlas_5_it", "assets/texture_atlas_5_it.png", "assets/texture_atlas_5_it.json");
        this.load.atlas("texture_atlas_5_ru", "assets/texture_atlas_5_ru.png", "assets/texture_atlas_5_ru.json");
        this.load.atlas("texture_atlas_5_fr", "assets/texture_atlas_5_fr.png", "assets/texture_atlas_5_fr.json");

        this.load.json("audiosprite", "assets/audio/audiosprite.json");

        this.load.on("progress", this.updateLoadedPercentage, this);
    }

    private updateLoadedPercentage(percentageLoaded: number): void {

        this.progressBar.clear();
        this.progressBar.fillStyle(0xFFFFFF);
        this.progressBar.fillRect(0, GameConstants.GAME_HEIGHT - 12, percentageLoaded * GameConstants.GAME_WIDTH, 12);
    }

    private loadHowl(): void {

        let json = this.cache.json.get("audiosprite");
        json = JSON.parse(JSON.stringify(json).replace("urls", "src"));
        json = JSON.parse(JSON.stringify(json).replace("../", ""));
        json = JSON.parse(JSON.stringify(json).replace("../", ""));

        AudioManager.howl = new Howl(json);

        AudioManager.howl.on("load", function(): void {
            GameManager.onGameAssetsLoaded();
        });
    }
}
